import React from 'react'

export const Solicitations = (): JSX.Element => {
  return <div>Solicitations</div>
}
